import { render, staticRenderFns } from "./Population.vue?vue&type=template&id=e2234d02&scoped=true&"
import script from "./Population.vue?vue&type=script&lang=js&"
export * from "./Population.vue?vue&type=script&lang=js&"
import style0 from "./Population.vue?vue&type=style&index=0&id=e2234d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2234d02",
  null
  
)

export default component.exports